import { Tab, Tabs, Tooltip } from '@mui/material';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../store/store';
import { RootState } from '../../reducers';
import { setSelectedTab } from '../../store/claimsManagement.slice';
import AdminTeams from './Teams/AdminTeams';
import TeamOptimizer from './TeamOptimizer/TeamOptimizer';
import HelpIcon from '@mui/icons-material/Help';
import optimizerHelpDocument from '../../assets/documents/TeamOptimizerHowTo.pdf';

const TeamsPage = (props) => {
    const { selectedTab } = useSelector((state: RootState) => state.claimsManagement);
    const dispatch = useAppDispatch();

    const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        dispatch(setSelectedTab(newValue));
    };

    useEffect(() => {
        document.title = props.title;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getBody = () => {
        return (
            <>
                <Tabs
                    variant="fullWidth"
                    value={selectedTab}
                    indicatorColor="secondary"
                    textColor="secondary"
                    onChange={handleTabChange}
                    aria-label="disabled tabs example"
                    centered
                >
                    <Tab label="Team Management" />
                    <Tab
                        label="Team Optimizer"
                        icon={
                            <Tooltip title="Team Optimizer Help Document">
                                <HelpIcon color="primary" cursor="pointer" onClick={() => window.open(`${optimizerHelpDocument}`, '_blank')} />
                            </Tooltip>
                        }
                        iconPosition="end"
                    />
                </Tabs>
                {selectedTab === 0 && <AdminTeams />}
                {selectedTab === 1 && <TeamOptimizer />}
            </>
        );
    };

    return getBody();
};

export default TeamsPage;
